/**
 * Call Attempt Atoms - State management for Call Attempts (Read-only)
 *
 * Call Attempts = Individual call attempts within sessions
 * Read-only from call_attempts table
 *
 * NO LOCAL TYPES - All types come from @/isomorphic/schemas
 *
 * NOTE: All action functions have been moved to actions/call-attempt-actions.ts
 * This file now only contains atom definitions (state)
 */

import { atom } from "jotai";
import type { CallAttempt } from "@/isomorphic/schemas";
import type { AtomStatus, AtomError } from "@/frontend/types/atoms";

// ============================================================================
// ATOMS
// ============================================================================

/**
 * Internal atom: Session call attempts (from API)
 * Exported for use in action functions
 */
export const _apiSessionCallAttemptsAtom = atom<CallAttempt[]>([]);

export const sessionCallAttemptsStatusAtom = atom<AtomStatus>("init");
export const sessionCallAttemptsErrorAtom = atom<AtomError>(null);
export const currentCallAttemptAtom = atom<CallAttempt | null>(null);
export const currentCallAttemptStatusAtom = atom<AtomStatus>("init");

/**
 * Public atom: Session call attempts
 */
export const sessionCallAttemptsAtom = atom<CallAttempt[]>((get) => {
  return get(_apiSessionCallAttemptsAtom);
});
